import customAxios from "./axiosConfig";
import { encodeQueryData } from "@/utils/"

const InvoiceService = {
  list (params) {
    const api_url = window.Urls['invoice-list']()
    return customAxios.get(api_url, { params: params })
  },
  loadNextPage (next_url) {
    return customAxios.get(next_url)
  },
  getPayment (payment_id) {
    const api_url = '/api/v2/invoice-payments/' + payment_id + '/'
    return customAxios.get(api_url)
  },
  retrieve (pk, params) {
    const api_url = window.Urls["invoice_detail"](pk)
    return customAxios.get(api_url, { params: params })
  },
  create (data) {
    const api_url = window.Urls['invoice-list']()
    return customAxios.post(api_url, data).then((response) => {
      if (window.mixpanel) {
        window.mixpanel.track("Invoices: create", {
          'number':response.data.number,
          'invoice_date': response.data.invoice_date,
          'payment term': response.data.payment_term,
          'has project': !!response.data.project,
          'has project reference': !!response.data.project_reference,
          'is paid up front': response.data.paid_up_front,
          'is vat reversed charge': response.data.vat_reversed_charge,
          'number of lines': response.data.invoice_lines.length,
          'total amount': response.data.total_amount,
          'currency': response.data.currency
        });
      }
      return response
    })
  },
  update (pk, data) {
    const api_url = window.Urls["invoice_detail"](pk)
    return customAxios.put(api_url, data)
  },
  partialUpdate (pk, data) {
    const api_url = window.Urls['invoice-detail'](pk)
    return customAxios.patch(api_url, data)
  },
  sendReport (pk, data) {
    const api_url = window.Urls['invoice_send_report'](pk)
    return customAxios.post(api_url, data)
  },
  getEmailReport (email_id) {
    const api_url = '/api/v2/email_message/' + email_id + '/'
    return customAxios.get(api_url)
  },
  emailIgnoreFailure (email_id) {
    const api_url = '/api/v2/email_message/' + email_id + '/ignore_faliure/'
    return customAxios.post(api_url)
  },
  getPeriodOptions (params) {
    const api_url = window.Urls['invoice-years']()
    return customAxios.get(api_url, { params: params })
  },
  customerList (params) {
    const api_url = window.Urls['invoice_customer_list']()
    return customAxios.get(api_url, { useCache: params?.useCache, params: params })
  },
  convertTotal (id, total_amount) {
    var headers = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    const api_url = window.Urls['invoice-convert-total'](id)
    return customAxios.post(api_url, total_amount, headers)
  },
  createPaidInvoice (data) {
    const api_url = window.Urls['invoice_create_paid_invoice']()
    return customAxios.post(api_url, data)
  },
  downloadUrl (invoice_id) {
    return window.Urls['invoice_download_pdf'](invoice_id)
  },
  downloadPremiumSubscriptionInvoice (invoice_id) {
    const api_url = window.Urls['invoice_download_premium_subscription_pdf'](invoice_id)

    return customAxios.get(api_url, { responseType: 'blob' }).then((response) => {
      return response
    })
  },
  getPremiumInvoices (params) {
    var api_url = window.Urls['invoice_get_premium_invoices']()
    return customAxios.get(api_url, { params: params })
  },
  getExchangeRates () {
    var api_url = window.Urls['exchangerate-list']()
    return customAxios.get(api_url)
  },
  createCredit (pk) {
    const api_url = window.Urls['invoice-create-credit'](pk)
    return customAxios.post(api_url)
  },
  destroy (pk) {
    const api_url = window.Urls['invoice-detail'](pk)
    return customAxios.delete(api_url)
  },
  copyInvoice (pk, data) {
    const api_url = window.Urls['invoice-copy'](pk)
    return customAxios.post(api_url, data)
  },
  totalAmounts (params) {
    const api_url = window.Urls['invoice_totals']()
    return customAxios.get(api_url, { params: params })
  },
  totalNet (params) {
    const api_url = window.Urls['invoice-total-net']()
    return customAxios.get(api_url, { params: params })
  },
  nextSendNumber (data) {
    const api_url = window.Urls['invoice-invoice-next-send-number']()
    return customAxios.post(api_url, data)
  },
  swapNumbers (pk, data) {
    const api_url = window.Urls['invoice_swap_numbers'](pk)
    return customAxios.post(api_url, data)
  },
  send (data) {
    const api_url = window.Urls['invoice-send'](data.invoiceId)
    return customAxios.post(api_url, data)
  },
  markAsSent (pk) {
    const api_url = window.Urls['invoice_mark_as_sent'](pk)
    return customAxios.get(api_url)
  },
  getLanguageOptions() {
    const api_url = window.Urls['invoice_language_options']()
    return customAxios.get(api_url)
  },
  getStatusOptions () {
    const api_url = window.Urls['invoice_get_status_options']()
    return customAxios.get(api_url)
  },
  invoiceReportList (pk, params) {
    const api_url = window.Urls['invoice_invoice_report_list'](pk)
    return customAxios.get(api_url, { params: params })
  },
  getNextInvoiceNumber(data){
    var api_url = window.Urls['invoice-next-invoice-number']();
    return customAxios.post(api_url, data);
  },
  invoicePdf (pk) {
    const api_url = window.Urls['invoice_get_send_invoice_pdf_url'](pk)
    return customAxios.get(api_url)
  },
  exportCSV(params) {
    var queryString = encodeQueryData(params)
    const api_url = window.Urls['invoice-export-invoices']() + "?" + queryString
    return customAxios.get(api_url, { params: params, responseType: 'blob' }).then((response) => {
      return response
    })
  },
  exportUBL(params) {
    const api_url = window.Urls['invoice_export_invoices_ubl']()
    return customAxios.get(api_url, {params: params})
  },
  exportZip(params) {
    const api_url = window.Urls['invoice_export_invoices_zip']()
    return customAxios.get(api_url, { params: params})
  },
  getInvoicePDFBlob (invoice_id) {
    const api_url = window.Urls['invoice_download_pdf'](invoice_id)
    return customAxios.get(api_url, { responseType: 'blob' }).then((response) => {
      return response
    })
  },
  getInvoiceUBLBlob(invoice_id){
    const api_url = window.Urls['invoice_ubl'](invoice_id)
    return customAxios.get(api_url, { responseType: 'blob' }).then((response) => {
      return response
    })
  },
}

export default InvoiceService;
